import { render, staticRenderFns } from "./ConcernProblem.vue?vue&type=template&id=8dd3a3c8&scoped=true"
import script from "./ConcernProblem.vue?vue&type=script&lang=js"
export * from "./ConcernProblem.vue?vue&type=script&lang=js"
import style0 from "./ConcernProblem.vue?vue&type=style&index=0&id=8dd3a3c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd3a3c8",
  null
  
)

export default component.exports